var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "sidebar-logo-container",
    class: {
      collapse: _vm.collapse
    }
  }, [_c("transition", {
    attrs: {
      name: "sidebarLogoFade"
    }
  }, [_vm.collapse ? _c("router-link", {
    key: "collapse",
    staticClass: "sidebar-logo-link",
    attrs: {
      to: "/"
    }
  }, [_c("img", {
    staticClass: "sidebar-hider-logo",
    attrs: {
      src: _vm.logoHider
    }
  })]) : _c("router-link", {
    key: "expand",
    staticClass: "sidebar-logo-link",
    attrs: {
      to: "/"
    }
  }, [[_vm.platformEnv === "demi" ? _c("img", {
    staticClass: "sidebar-logo",
    attrs: {
      src: require("@/assets/logo-demi.png")
    }
  }) : _vm.platformEnv === "qyzy" ? _c("img", {
    staticClass: "sidebar-logo",
    attrs: {
      src: require("@/assets/logo-qyzy.png")
    }
  }) : _c("img", {
    staticClass: "sidebar-logo",
    attrs: {
      src: require("@/assets/logo-qyd.png")
    }
  }), _c("h1", {
    staticClass: "sidebar-title"
  }, [_vm._v(" " + _vm._s(_vm.platformEnv === "demi" ? _vm.title : "众包") + " ")])]], 2)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };